import type { IconCustomProps } from "./icon-custom.type";

import Icon from "@ant-design/icons";

import { getIconComponent } from "./icon-custom.helper";

export const IconCustom = ({ type, ...iconProps }: IconCustomProps) => {
  const component = getIconComponent(type);

  if (!component) return null;

  return <Icon aria-label={type} {...iconProps} component={component} />;
};
